// extracted by mini-css-extract-plugin
export default {"media":"MediaPreview_media__ubFpy","previewContainer":"MediaPreview_previewContainer__zJe-i"};